<template>
  <div>
    <el-dialog
        :title="organisationTitle"
        :visible.sync="organisationStructureVisible"
        :width="deptWidth"
        :before-close="organizationClose"
        :append-to-body="appendBody"
        :top="'5vh'"
    >
      <div class="test-component">
        <div class="flex-box">
          <div class="select-title">浙政钉组织架构</div>
          <!--          <el-tabs-->
          <!--            v-if="isShowLeader"-->
          <!--            v-model="tabActive"-->
          <!--            class="tab-head"-->
          <!--            @tab-click="changeType"-->
          <!--          >-->
          <!--            <el-tab-pane label="部门" name="first" />-->
          <!--            <el-tab-pane label="领导" name="second" />-->
          <!--          </el-tabs>-->
          <div
              v-show="tabActive === 'first'"
              v-loading="treeLoading"
              class="selecting-box select-box-content"
          >
            <!-- 部门搜索框 -->
            <el-input
                v-model="searchValue"
                placeholder="请输入搜索的部门"
                @change="searchInput"
            >
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  :loading="searchLoading"
                  type="primary"
                  @click="searchInput"
              />
            </el-input>
            <!--搜索的展示列表-->
            <ul
                v-show="searchShowList.length > 0"
                ref="ulList"
                class="select-list"
            >
              <li
                  v-for="select in searchShowList"
                  :key="select.value"
                  class="select-list-item"
              >
                <el-checkbox
                    ref="checkboxes"
                    v-model="select.isChecked"
                    class="tree-class-item-checkbox"
                    name="select.id"
                    :disabled="select.disabled"
                    @change="triggerCheckbox(select)"
                />
                <div
                    class="tree-class-item-cell"
                    @click="chooseSreachItem(select)"
                >
                  {{ select.cname }}
                </div>
              </li>
            </ul>
            <el-pagination
                v-show="searchShowList.length > 0"
                background
                hide-on-single-page
                :pager-count="pagerCount"
                small
                layout="prev, pager, next"
                :total="allCount"
                :current-page.sync="curPage"
                @current-change="handleCurrentChange"
            />
            <!-- 面包屑 -->
            <breadcrumb
                v-show="searchValue.length === 0"
                :breadList="breadList"
                @changeBread="changeBread"
            />
            <!-- 层级展示 -->
            <div
                v-show="searchValue.length === 0"
                ref="selectList"
                class="tree-class-list-box"
            >
              <div
                  v-for="(select, index) in selectClassList"
                  :key="select.id"
                  class="tree-class-item-box"
              >
                <el-checkbox
                    ref="checkboxes1"
                    v-model="select.isChecked"
                    class="tree-class-item-checkbox"
                    name="select.id"
                    :disabled="select.disabled"
                    @change="triggerCheckbox(select)"
                />
                <div
                    class="tree-class-item-cell"
                    @click.stop="clickToSelectAllNext(select)"
                >
                  {{ select.clabel }}
                </div>
                <div
                    class="tree-class-item-icon"
                    @click.stop="clickToNextClass(select, false)"
                >
                  <i class="el-icon-arrow-right"/>
                </div>
              </div>
            </div>
            <!-- 全选 -->
            <div class="selecting-box-all">
              <el-button
                  class="selecting-box-all-btn"
                  type="text"
                  @click="selectAll"
              >全选
              </el-button>
            </div>
          </div>
          <div
              v-show="tabActive === 'second'"
              v-loading="treeLoading"
              class="selecting-box select-box-content leader"
          >
            <!--领导列表-->
            <el-tree
                ref="treeDom"
                :props="props"
                :load="loadNode"
                lazy
                show-checkbox
                node-key="ids"
                :default-checked-keys="selectedLeaderValue"
                @check-change="handleCheckChange"
                @check="handleCheckClick"
            />
            <!-- 全选 -->
            <div class="selecting-box-all">
              <el-button
                  class="selecting-box-all-btn"
                  type="text"
                  @click="selectAllLeader"
              >全选
              </el-button>
            </div>
          </div>
        </div>
        <div class="right-icon">
          <i class="el-icon-arrow-right" style="font-size: 16px"/>
        </div>
        <div class="flex-box">
          <div class="select-title">已选中</div>
          <div class="selected-box select-box-content">
            <div class="tags tree-class-list-box">
              <el-tag
                  v-for="(tag, index) in selectedList"
                  :key="index"
                  class="selected-item"
                  closable
                  @close="closeTag(tag.value, $event)"
              >{{ tag | showTagName }}
              </el-tag>
            </div>

            <div class="selected-item-cancel">
              <el-button
                  class="selected-item-cancel-btn"
                  type="text"
                  icon="el-icon-delete"
                  @click="deleteAll"
              >
                清空所有
              </el-button>

              <div class="statistics">
                已选中数量：{{ selectedList.length }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-divider/>
        <div class="footer-tips">
          <p style="color: #ff0000">当前仅支持选择已开通部门账号的部门</p>
          <el-button type="primary" @click="organizationClose">确 定</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// eslint-disable-next-line no-extend-native
import {CheckAll} from './checkAll';
import {searchZzdGroupListPromise, getZzdGroupListPromise} from '@/api/remote-search';
import breadcrumb from './BreadCrumb';
import {LeaderRoleList} from './leader.js';

// eslint-disable-next-line no-extend-native
Array.prototype.remove = function (val) {
  const index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};
// eslint-disable-next-line no-extend-native
Array.prototype.removeObj = function (val) {
  const index = this.findIndex((ele) => ele.value === val);
  if (index > -1) {
    this.splice(index, 1);
  }
};

/**
 * 筛选出自身属性的层级
 * @param data 待处理的部门对象
 * @param returnObj 返回层级value和label的对象,默认不传
 */
function filterOwnTier(
    data,
    returnObj = {tierValue: [], tierLabel: [], value: '', label: ''}
) {
  returnObj.value = returnObj.value ? returnObj.value : data.id;
  returnObj.label = returnObj.label ? returnObj.label : data.name;
  returnObj.tierValue.unshift(data.id);
  returnObj.tierLabel.unshift(data.name);
  if (Object.prototype.hasOwnProperty.call(data, 'f_dept')) {
    return filterOwnTier(data.f_dept, returnObj);
  } else {
    return returnObj;
  }
}

export default {
  name: 'TestComponent',
  components: {breadcrumb},
  filters: {
    showTagName(data) {
      // console.log(data, 'filters');
      return data.fullLabel
          ? data.fullLabel
          : data.clabel
              ? data.clabel
              : data.name;
    }
  },
  model: {
    prop: 'deptObj',
    event: 'changeObj'
  },
  props: {
    deptObj: {
      type: Object,
      default() {
        return {};
      }
    },
    // 弹窗的显示与关闭
    organisationStructureVisible: {
      type: Boolean,
      default: false
    },
    // 弹窗的标题
    organisationTitle: {
      type: String,
      default: '组织架构'
    },
    // 弹窗大小
    deptWidth: {
      type: String,
      default: '70%'
    },
    // 嵌套dialog
    appendBody: {
      type: Boolean,
      default: false
    },
    // 是否显示领导tab
    // isShowLeader: {
    //   type: Boolean,
    //   default: false
    // }
    tabActive: {// tab切换，默认选择部门
      type: String,
      default: 'first'
    }
  },
  data() {
    return {
      searchValue: '', // 搜索值
      searchLoading: false,
      treeLoading: false,
      searchShowList: [], // 搜索结果列表
      treeFlatJson: [], // 部门平级数据
      selectClassList: [], // 层形数据
      selectedList: [], // 已选中的对象数组，用于展示的tag数组
      selectedDeptList: [], // 已选中的部门数组
      selectedValue: [], // 已选中的value数组
      selectedTierValue: [], // 已选中的带层级的二维value数组
      selectedTierLabel: [], // 已选中的带层级的二维label数组
      breadList: [{id: -1, clabel: '杭州市'}], // 面包屑数组{id: -1, clabel: '萧山区'}
      curPage: 1, // 当前页码
      allCount: 0, // 总条数
      pagerCount: 5, // 分页器最多显示页码按钮的数量
      leaderRoleList: '', // 领导列表
      leaderCheckedList: [], // 已选中领导数组
      props: {
        label: 'name',
        children: 'zones'
      },
      count: 1,

      checkAll: [] // 默认全选列表
    };
  },
  computed: {
    // 已选中的label数组
    selectedLabel() {
      const arr = [];
      this.selectedDeptList.forEach((ele) => {
        const label = ele.clabel ? ele.clabel : ele.name;
        // console.log(label, '已选中的label数组');
        arr.push(label);
      });
      this.$forceUpdate();
      // console.log(arr, 'arr');
      return arr;
    },
    // 已选中的完整的label数组
    selectedFullLabel() {
      const arr = [];
      this.selectedDeptList.forEach((ele) => {
        arr.push(ele?.fullLabel);
      });
      this.$forceUpdate();
      // console.log(arr, 'arr');
      return arr;
    },
    // 已选中领导label
    selectedLeaderLabel() {
      const arr = [];
      this.leaderCheckedList.forEach((ele) => {
        arr.push(ele.name);
      });
      this.$forceUpdate();
      // console.log(arr, 'arr');
      return arr;
    },
    // 已选中领导id数组
    selectedLeaderValue() {
      const arr = [];
      try {
        this.leaderCheckedList.forEach((ele) => {
          this.$refs.treeDom.setChecked(ele.ids, true, false);
        });
        // console.log(this.$refs.treeDom, '已选中领导id数组');
      } catch (err) {
        console.log(err);
      }
      this.leaderCheckedList.forEach((ele) => {
        arr.push(ele.ids);
      });
      return arr;
    }
  },
  watch: {
    deptObj: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        if (
            newVal !== oldVal &&
            Object.hasOwnProperty.call(newVal, 'value_name') &&
            Object.hasOwnProperty.call(newVal, 'value')
        ) {
          this.selectedList.length = 0;
          this.leaderCheckedList.length = 0;
          this.selectedDeptList.length = 0;
          if (this.tabActive === 'first') {
            // 部门数据
            newVal.value_name.forEach((ele, cid) => {
              const obj = {
                clabel: ele,
                fullLabel: ele,
                value: newVal.value[cid],
                isChecked: true, // 默认属性
                leaf: true, // 默认属性
                disabled: false // 默认属性
              };
              this.selectedList.push(obj);
              this.selectedDeptList.push(obj);

            });
          } else {
            // 领导数据
            newVal?.value_name.forEach((ele, cid) => {
              const obj = {
                clabel: ele,
                name: ele,
                ids: newVal.value[cid],
                value: newVal.value[cid],
                isChecked: true, // 默认属性
                leaf: true, // 默认属性
                disabled: false // 默认属性
              };
              this.selectedList.push(obj);
              this.leaderCheckedList.push(obj);
            });
          }

          this.selectedValue = [...newVal.value];
        }
      }
    },
    searchValue(newVal) {
      if (newVal.length === 0) {
        this.searchShowList.length = 0;
      }
    },
    selectedValue: {
      deep: true,
      immediate: true,
      handler(newVal) {
        // 层级列表双向绑定
        this.selectClassList.forEach((ele) => {
          ele.isChecked = false;
        });
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            const tempIndex = this.selectClassList.findIndex(
                (ele) => ele.value === item
            );
            if (tempIndex !== -1) {
              this.selectClassList[tempIndex].isChecked = true;
            }
          });
        }
        // 搜索列表双向绑定
        this.searchShowList.forEach((ele) => {
          ele.isChecked = false;
        });
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            const tempIndex = this.searchShowList.findIndex(
                (ele) => ele.value === item
            );
            if (tempIndex !== -1) {
              this.searchShowList[tempIndex].isChecked = true;
            }
          });
        }
      }
    }
  },
  mounted() {
    this.treeLoading = true;
    this.leaderRoleList = LeaderRoleList;
    this.checkAll = CheckAll.map((e) => ({...e, isChecked: false}));
    this.loadTreeJson();
  },
  methods: {
    // 获取树形数据
    async loadTreeJson(id = -1) {
      const res = await getZzdGroupListPromise(id);
      if (res.data) {
        res.data.forEach((ele) => {
          ele.disabled = !ele.leaf; // 是否能被选中，true为不能
          ele.pid = id; // 父级id
          ele.fullLabel = id; // 完整层级label
          ele.clabel = ele.label; // 统一字段必须 value字段默认存在
          // 反显
          ele.isChecked = false;
          if (this.selectedValue.some((item) => item === ele.value)) {
            ele.isChecked = true;
          }
          // 防止重复
          if (!this.treeFlatJson.some((item) => item.value === ele.value)) {
            this.treeFlatJson.push(ele);
          }
        });
        const tempArr = [];
        tempArr.push(...res.data);
        this.selectClassList.length = 0;
        this.selectClassList = tempArr;
        this.$refs.selectList.scrollTop = 0; // 滚动到顶部
        this.treeLoading = false;
        return res.data;
      } else {
        this.treeLoading = false;
        return [];
      }
    },
    // 关闭已有的tag
    closeTag(value) {
      this.selectedList.removeObj(value);
      try {
        this.selectedDeptList.removeObj(value);
      } catch (err) {
        console.log(err, 'try catch');
      }
      const checkIndex = this.checkAll.findIndex((ele) => ele.value === value);
      if (checkIndex !== -1) {
        this.checkAll[checkIndex].isChecked = false;
      }

      const tempIndex = this.leaderCheckedList.findIndex(
          (ele) => ele.ids === value
      );
      if (tempIndex !== -1) {
        this.leaderCheckedList.splice(tempIndex, 1);
      }
      this.$refs.treeDom.setChecked(value, false, false);

      this.selectedValue.remove(value);
      this.changeDeptObj();
      this.$forceUpdate();
    },
    // 模糊搜索
    searchInput() {
      this.searchLoading = true;
      if (this.searchValue !== '') {
        this.curPage = 1;
        this.getSearchList();
      } else {
        this.searchLoading = false;
      }
    },
    // 获取搜索列表
    getSearchList() {
      this.treeLoading = true;
      searchZzdGroupListPromise(
          this.searchValue.trim() + `&page=${this.curPage}`
      )
          .then((res) => {
            this.allCount = res.all_count;
            // console.log(res, 'enter');
            res.item.forEach((ele) => {
              ele.value = ele.id; // 统一字段必须
              ele.clabel = ele.name; // 统一字段必须
              ele.label = ele.name; // 统一字段
              // 反显是否选中
              ele.isChecked = false;
              if (this.selectedValue.some((item) => item === ele.value)) {
                ele.isChecked = true;
              }
              // 递归查找出搜索结果的所有层级
              const obj = filterOwnTier(ele);
              if (
                  obj !== null &&
                  typeof obj === 'object' &&
                  obj.tierLabel.length > 0
              ) {
                ele.cname = obj.tierLabel.join(' / ');
              } else {
                ele.cname = ele.name;
              }
              ele.tier = obj;
              // 判断是否被禁选
              ele.disabled = false;
              // ele.disabled = !ele.leaf;
              // 防止数组重复
              if (!this.treeFlatJson.some((item) => item.value === ele.value)) {
                this.treeFlatJson.push(ele);
              }
              ele.fullLabel = ''; // 完整层级label
            });
            const temp = res.item;
            this.searchShowList.length = 0;
            this.searchShowList.push(...temp);
            this.$refs.ulList.scrollTop = 0; // 滚动跳回到顶部
            this.searchLoading = false;
            this.treeLoading = false;
          })
          .catch(() => {
            this.searchLoading = false;
            this.treeLoading = false;
          });
    },
    // 页码组件切换
    handleCurrentChange(val) {
      this.curPage = val;
      this.searchLoading = true;
      this.getSearchList();
    },
    /**
     * 切换选择
     * @param data 当前选择的
     * @param flag 是否完整展示路径
     */
    triggerCheckbox(data, flag = true) {
      if (!data.disabled) {
        const tempIndex = this.selectedList.findIndex(
            (ele) => ele.value === data.value
        );
        // console.log(tempIndex, 'tempIndex');
        // 选中时
        if (data.isChecked && tempIndex === -1) {
          const fullLabel = this.breadList
              .reduce((full, current) => {
                return full + ' /' + current.clabel;
              }, '')
              .trim();
          // console.log(fullLabel.length, 'fullLabel*************************', fullLabel);
          data.fullLabel = flag
              ? fullLabel.substring(1, fullLabel.length).trim() +
              ' /' +
              data.clabel
              : data.clabel;
          // console.log(data.fullLabel.length, 'fulllabel*********', data.fullLabel);
          this.selectedList.push(data);
          this.selectedDeptList.push(data);
          this.selectedValue.push(data.value);
        } else {
          // 取消选择时
          this.selectedList.removeObj(data.value);
          this.selectedDeptList.removeObj(data.value);
          this.selectedValue.remove(data.value);
        }
        this.changeDeptObj();
        // this.$forceUpdate();
      }
    },
    // 选中搜索结果
    chooseSreachItem(data) {
      data.isChecked = !data.isChecked;
      this.triggerCheckbox(data);
    },
    // 选中当前列表所有
    selectAll() {
      let selectArray = [];
      selectArray =
          this.searchShowList.length > 0 ? this.searchShowList : this.checkAll;

      // 全选筛选
      const noSelect = [20374, 20521, 22067, 21905, 23623, 23618, 23552, 23346, 23638, 23637, 23597, 23628];
      selectArray.forEach((select) => {
        if (!select.isChecked && !select.disabled && noSelect.indexOf(select.ids) === -1) {
          select.isChecked = true;
          this.triggerCheckbox(select, false);
        }
      });
    },
    // 选中所有领导
    selectAllLeader() {
      this.leaderRoleList.forEach((ele) => {
        // this.handleCheckClick(ele);
        this.handleCheckChange(ele, true);
      });
    },
    // 清空所有已选中
    deleteAll() {
      if (this.selectedList.length === 0) return;
      this.$confirm('此操作将清空所有已选中, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            this.selectedList = [];
            this.leaderCheckedList = [];
            this.selectedDeptList = [];
            this.selectedValue = [];
            const node = this.$refs.treeDom.getCheckedNodes();
            node.forEach((ele) => {
              this.$refs.treeDom.setChecked(ele.ids, false, false);
              ele.checked = false;
            });

            this.checkAll.forEach((ele) => {
              ele.isChecked = false;
            });
            // console.log(node, 'node');
            // this.$refs.treeDom.setCurrentNode(node);
            this.changeDeptObj();
            // this.$forceUpdate();
            this.$message({
              type: 'success',
              message: '已清空'
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
    },
    // 切换面包屑
    async changeBread(data) {
      // console.log(data, '切换面包屑');
      const tempIndex = this.breadList.findIndex((ele) => ele.id === data.id);
      if (tempIndex !== -1) {
        this.treeLoading = true;
        await this.loadTreeJson(data.id);
        this.breadList.splice(
            tempIndex + 1,
            this.breadList.length - tempIndex - 1
        );
      }
    },
    // 点击进入下一级
    async clickToNextClass(data, toLeader = false) {
      // console.log(data, '点击进入下一级');
      this.treeLoading = true;
      if (toLeader) {
        this.clickToNextLeaderClass(data);
        return;
      }
      if (!this.breadList.some((ele) => ele.value === data.value)) {
        const temp = await this.loadTreeJson(data.value);
        // console.log(temp, '261');
        if (temp.length > 0) {
          this.breadList.push({clabel: data.clabel, id: data.value});
        } else {
          // this.$toast('该层级没有下一级!');
          this.$message({
            message: '该层级没有下一级!',
            type: 'warning'
          });
        }
        this.treeLoading = false;
      }
    },
    // 领导列表点击进入下一级
    clickToNextLeaderClass(data) {
      this.getUserByRoleId(data.id);
    },
    // 点击进入下一级，并且选中全部子级
    async clickToSelectAllNext(data) {
      await this.clickToNextClass(data);
      // this.selectAll();
    },
    // v-model的双向绑定
    changeDeptObj() {
      this.$emit('changeObj', {
        value: this.tabActive === 'first' ? this.selectedValue : this.selectedLeaderValue,
        value_name: this.tabActive === 'first' ? this.selectedLabel : this.selectedLeaderLabel
        //     deptValue: this.selectedValue,
        // deptLabel: this.selectedLabel,
        // deptLabelName: this.selectedLabel.join('、'),
        // deptFullLabel: this.selectedFullLabel,
        //
        // leaderValue: this.selectedLeaderValue, // 领导id
        // leaderLabel: this.selectedLeaderLabel, // 领导label
        // leaderLabelName: this.selectedLeaderLabel.join('、')
      });
    },
    // 组织架构弹窗关闭事件
    organizationClose() {
      this.$emit('organizationClose');
    },
    // 切换tab
    changeType(data) {
      // console.log(data.name, this.tabActive);
    },
    // 根据角色获取用户列表
    getUserByRoleId(id) {
      return new Promise((resolve, reject) => {
        this.$api
            .get('/manager/crm/member/list', {
              role_arr: JSON.stringify([id]),
              size: 100
            })
            .then((res) => {
              this.treeLoading = false;
              if (res.all_count === 0) {
                this.$message({
                  message: '该层级没有下一级!',
                  type: 'warning'
                });
              }
              // // 反显
              // ele.isChecked = false;
              // if (this.selectedValue.some((item) => item === ele.value)) {
              //   ele.isChecked = true;
              // }
              const arr = [];
              res.item.forEach((ele) => {
                const obj = {
                  ...ele,
                  checked: true
                };
                arr.push(obj);
              });
              resolve(arr);
            })
            .catch((err) => {
              reject(err);
            });
      });
    },
    // 领导tree点击checkbox
    handleCheckClick(data) {
      if (!data.checked) {
        this.closeTag(data.ids);
      }
      data.checked = !data.checked;
    },
    // 领导tree的checkbox改变时
    handleCheckChange(data, checked) {

      if (checked) {
        data.value = data.ids;
        const tempIndex = this.leaderCheckedList.findIndex(
            (ele) => ele.ids === data.ids
        );
        if (tempIndex === -1) {
          this.leaderCheckedList.push(data);
          this.selectedList.push(data);
          data.checked = true;
          this.$refs.treeDom.setChecked(data.ids, true, false);
        }
      } else {
        const tempIndex = this.leaderCheckedList.findIndex(
            (ele) => ele.ids === data.ids
        );
        // console.log(tempIndex, 'tempIndex');
        if (tempIndex !== -1) {
          this.leaderCheckedList.splice(tempIndex, 1);
        }
        this.$refs.treeDom.setChecked(data.ids, false, false);
        data.checked = false;

        this.selectedList.removeObj(data.ids);
      }
      this.changeDeptObj();
    },
    handleNodeClick(data) {
    },
    async loadNode(node, resolve) {
      // console.log(node.level, resolve, 'loadNode');
      if (node.level === 0) {
        return resolve(this.leaderRoleList);
      }
      if (node.level > 0) return resolve([]); // 下钻0层
      const cb = await this.getUserByRoleId(node.data.id);
      // console.log(cb, 'cb');
      resolve(cb);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.el-dialog {
  // width: 80% !important;

  .footer-tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

::v-deep.el-dialog__body {
  padding: 0 20px;
}

::v-deep.el-divider--horizontal {
  margin: 10px 0;
}

.test-component {
  display: flex;
  justify-content: space-around;
  align-items: center;

  .flex-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .select-title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      border: 1px solid #d6d6d6;
      border-bottom: 1px solid transparent;
      color: #0b95ff;
      text-align: center;
    }

    .tab-head {
      border: 1px solid #d6d6d6;
      border-bottom: none;
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
    }

    .select-box-content {
      width: 25vw;
      height: 55vh;
      padding: 10px 20px 40px;
      border: 1px solid #d6d6d6;
      display: flex;

      .tags {
        height: 53vh;
        overflow-y: auto;
      }
    }

    .tree-class-list-box {
      // flex: 1;
      width: 100%;
      height: calc(55vh - 120px);
      overflow-y: scroll;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #3584d9;
      }

      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #ededed;
      }

      .tree-class-item-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 10px;
        border-bottom: 1px solid #f6f7f9;

        .tree-class-item-checkbox {
          padding: 5px 10px;
          height: 100%;
          display: flex;
          justify-content: flex-end;
          word-wrap: break-word;
        }

        .tree-class-item-cell {
          height: 100%;
          padding: 5px 16px 5px 0;
          cursor: pointer;
          // word-wrap: break-word;
          line-height: 1.5;
        }

        .tree-class-item-icon {
          cursor: pointer;
          height: 100%;
          padding: 10px 16px 10px 0;
          flex: 1;
          text-align: right;
          line-height: 0 !important;
        }
      }
    }

    .selecting-box {
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      position: relative;

      .select-list {
        width: 100%;
        height: auto;
        overflow-y: scroll;
        flex: 1;
        background: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        &::-webkit-scrollbar {
          width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
          height: 8px;
        }

        &::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 10px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #3584d9;
        }

        &::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          border-radius: 10px;
          background: #ededed;
        }

        .select-list-item {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          border-bottom: 1px solid #f6f7f9;

          .tree-class-item-cell {
            width: 90%;
            // word-wrap: break-word;
            cursor: pointer;
            line-height: 1.5;
          }
        }
      }

      .select-tree {
        /*display: none;*/
        width: 100%;
        height: auto;
        overflow-y: scroll;
        flex: 1;
      }

      &-all {
        position: absolute;
        left: 20px;
        bottom: 0px;
      }
    }

    .selected-box {
      flex-wrap: wrap;
      align-items: flex-start;
      align-content: flex-start;
      justify-content: flex-start;
      position: relative;
      height: calc(55vh + 50px);

      .selected-item {
        margin: 5px 10px;
        white-space: break-spaces;
        height: auto;
      }

      .selected-item-cancel {
        position: absolute;
        left: 0px;
        bottom: 0px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;

        .selected-item-cancel-btn {
          color: red;
        }

        // .statistics {
        // }
      }
    }
  }

  .right-icon {
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 1px solid #d6d6d6;
    border-radius: 10px;
  }
}

::v-deep.el-tree {
  width: 100%;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #3584d9;
  }

  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #ededed;
  }
}
</style>
